import PropTypes from 'prop-types';

export const LIVE_QA_FEATURE_CODE = 'LIVE_QA';

export const QAStatusTypes = Object.freeze({
  NOT_STARTED: 'NOT_STARTED',
  DURING: 'DURING',
  ENDED: 'ENDED'
});

export const QuestionStatus = Object.freeze({
  APPROVED: 'approved',
  DECLINED: 'declined',
  ANSWERED: 'answered',
  PENDING: 'pending'
});

export const SortType = Object.freeze({
  MOST_VOTES: 'votes',
  MOST_RECENT: 'recent'
});

export const ModeratorSettings = Object.freeze({
  TIME: 'timeSettings',
  CODE: 'sessionCodes',
  ANONYMITY_SETTINGS: 'anonymitySettings'
});

export const LiveQATimeType = Object.freeze({
  SESSION_TIME: 'sessionTime',
  QA_CUSTOM_TIME: 'customQATime'
});

export const QuestionProptypes = {
  // Question Id
  id: PropTypes.string.isRequired,
  // Question text
  text: PropTypes.string.isRequired,
  // Id of the question's owner
  attendeeId: PropTypes.string,
  // Name of the question's owner
  attendeeName: PropTypes.string,
  // firstName of the question's owner
  firstName: PropTypes.string,
  // lastName of the question's owner
  lastName: PropTypes.string,
  // Indicate the ownership of the question
  isOwner: PropTypes.bool,
  // Number of votes
  voteCount: PropTypes.number,
  // Indicates if the creator of the question has asked this anonymously
  isAnonymous: PropTypes.bool,
  // Indicates if the user has voted to this question
  isVoted: PropTypes.bool,
  // Status of the question
  status: PropTypes.oneOf(Object.values(QuestionStatus)),
  // Current question flag
  isCurrentQuestion: PropTypes.bool,
  // Date when the question status changed
  statusChangeDateTime: PropTypes.string
};
export type QAQuestionProps = {
  id: string;
  text: string;
  attendeeId: string;
  attendeeName: string;
  firstName: string;
  lastName: string;
  isOwner: boolean;
  voteCount: number;
  isAnonymous: boolean;
  isVoted: boolean;
  isCurrentQuestion: boolean;
  status: 'approved' | 'declined' | 'answered' | 'pending';
  statusChangeDateTime: string;
};

export type QAQuestionListSortOrder = 'votes' | 'recent';

type ActionProps = {
  callback: () => void;
  isDisabled: boolean;
};

export type QAActionsProps = {
  upVote: ActionProps;
  approve: ActionProps;
  decline: ActionProps;
  display: ActionProps;
  unset: ActionProps;
};

export const QuestionListPropTypes = {
  approved: PropTypes.arrayOf(PropTypes.shape(QuestionProptypes)),
  answered: PropTypes.arrayOf(PropTypes.shape(QuestionProptypes)),
  pending: PropTypes.arrayOf(PropTypes.shape(QuestionProptypes)),
  declined: PropTypes.arrayOf(PropTypes.shape(QuestionProptypes)),
  currentQuestion: PropTypes.shape(QuestionProptypes)
};

export const ActionDefinitionProptypes = {
  callback: PropTypes.func,
  isDisabled: PropTypes.bool
};

export const ActionsProptypes = {
  upVote: PropTypes.shape(ActionDefinitionProptypes),
  approve: PropTypes.shape(ActionDefinitionProptypes),
  decline: PropTypes.shape(ActionDefinitionProptypes),
  display: PropTypes.shape(ActionDefinitionProptypes),
  unset: PropTypes.shape(ActionDefinitionProptypes)
};

export const UserProptypes = {
  id: PropTypes.string,
  visibility: PropTypes.number,
  // whether this user is a moderator
  canModerate: PropTypes.bool,
  // first name of the user
  firstName: PropTypes.string,
  // last name of the user
  lastName: PropTypes.string,
  // previous selection of the anonymous checkbox
  previousAnonymousCheckboxSetting: PropTypes.bool,
  // whether this user needs to see the anonymous disclaimer
  canSeeAnonymousMessage: PropTypes.bool
};

export const AttendeeVisibility = Object.freeze({
  UNSET: 0,
  PUBLIC: 1,
  PRIVATE: 2
});

export const ModeratorLinksAndCodesPropTypes = {
  liveDisplayShortUrl: PropTypes.string,
  accessCode: PropTypes.string,
  locationCode: PropTypes.string
};

export const DEFAULT_PENDING_TAB = 1;

/**
 * Ratio of approval questions to reach for showing a warning message
 * Example if the number of approval questions reaches: LIMIT * APPROVAL_QUESTION_LIMIT_RATIO
 * then a warning message has to be shown
 */
export const APPROVAL_QUESTION_LIMIT_RATIO = 0.8;

export const QUESTIONS_LIMIT = 9999;

export const DEBOUNCE_RENDERING_INTERVAL = 7000;

export const LiveQASubscriptions = Object.freeze({
  ATTENDEE: ['approved', 'answered', 'declined'],
  MODERATOR: ['all']
});

export const LIVE_QA_BUFFER_MINUTES = 15;
